export interface MangaItem {
  id: string;
  title: string;
  slug: string;
  coverImage: string;
  category: string;
  categorySlug: string;
  author: string;
  status: string;
  description: string;
  rating: number;
  views: number;
  chapters: number;
  updatedAt: string;
  tags: string[];
  content?: string;
}

export interface CategoryInfo {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: CategoryInfo[] = [
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line', count: 128 },
  { name: '动作', slug: 'action', icon: 'ri-sword-line', count: 95 },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line', count: 112 },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line', count: 76 },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line', count: 89 },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line', count: 54 },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line', count: 103 },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line', count: 67 },
];

export const mangaList: MangaItem[] = [
  {
    id: 'manga-001',
    title: '秘密花园的秘密',
    slug: 'secret-garden-secret',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20romance%20cover%20art%2C%20two%20young%20characters%20in%20a%20beautiful%20garden%20setting%2C%20soft%20warm%20lighting%2C%20delicate%20lineart%2C%20pastel%20color%20palette%2C%20manga%20illustration%20with%20clean%20composition%2C%20emotional%20atmosphere%2C%20shojo%20aesthetic&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    author: '金智秀',
    status: '连载中',
    description: '在一个神秘的花园里，两个年轻人的命运悄然交织。她是一个普通的高中生，而他却隐藏着不为人知的秘密。当花瓣飘落的季节来临，一段甜蜜又心动的故事就此展开。',
    rating: 9.2,
    views: 1285000,
    chapters: 86,
    updatedAt: '2026-08-04',
    tags: ['校园', '甜蜜', '治愈', '青春'],
    content: '<h2>第一章：意外的相遇</h2><p>首尔的春天来得格外早。樱花已经盛开，粉色的花瓣随风飘舞，落在林荫道上，铺成一条浪漫的小径。</p><p>林智雅抱着画板匆匆走在校园里，她今天又迟到了。作为美术系的大一新生，她总是沉浸在自己的世界里，忘记了时间。</p><p>"啊——"</p><p>转角处，她撞上了一个人。画板、颜料、画笔散落一地。</p><p>"对不起！对不起！"她慌忙蹲下身去捡。</p><p>一只修长的手帮她捡起了掉落的画笔。她抬起头，看到了一张让她心跳漏拍的脸。</p><p>那是大二建筑系的学长——朴灿宇。全校女生都为之疯狂的校园男神。</p><p>"没关系。"他微微一笑，把画笔递给她，"你的画很漂亮。"</p><p>智雅愣住了。她画的是昨天在花园里看到的一只小猫，画得歪歪扭扭的，哪里漂亮了？</p><p>但朴灿宇的目光很认真。他指着画中角落里的一朵小花说："这朵玫瑰画得很有灵气。"</p><p>智雅的脸一下子红了。那朵花是她随手画的，没想到竟然被注意到了。</p><p>从那天起，她的生活开始发生了微妙的变化。朴灿宇总是出现在她意想不到的地方——图书馆、食堂、甚至她常去的那个小花园。</p><p>"又见面了。"每次相遇，他都会这样说。</p><p>智雅不知道，这一切并非巧合。朴灿宇有一个秘密——他搬到这个城市，来到这所大学，都是为了找到那个十年前在秘密花园里给过他温暖的人。</p><p>而那个人，就是她。</p>',
  },
  {
    id: 'manga-002',
    title: '暗夜狩猎者',
    slug: 'night-hunter',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20action%20cover%20art%2C%20a%20powerful%20male%20hunter%20character%20in%20dark%20urban%20setting%2C%20dramatic%20lighting%20with%20moonlight%2C%20dynamic%20pose%2C%20dark%20color%20scheme%20with%20red%20accents%2C%20intense%20atmosphere%2C%20clean%20manga%20illustration%20style&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    author: '李俊浩',
    status: '连载中',
    description: '在首尔的暗夜中，一位神秘的猎手守护着城市。他有着不为人知的能力，追踪着隐藏在人类世界中的邪恶力量。每一场战斗，都是生与死的较量。',
    rating: 9.5,
    views: 2150000,
    chapters: 124,
    updatedAt: '2026-08-03',
    tags: ['战斗', '超能力', '热血', '都市'],
    content: '<h2>第一章：夜幕降临</h2><p>午夜十二点，首尔的霓虹灯依然闪烁。但在繁华街道的阴影中，隐藏着普通人看不见的威胁。</p><p>韩俊浩站在高楼顶端，夜风吹动他黑色的风衣。他的双眼在黑暗中泛着淡淡的金色光芒——那是猎手一族的标志。</p><p>"找到了。"他低声说道。</p><p>在三条街外的废弃工厂里，一只暗影兽正在蠢蠢欲动。它已经吞噬了三个无辜者的灵魂，今晚，它将不再有作恶的机会。</p><p>俊浩纵身一跃，身体在半空中划出一道完美的弧线。落地时悄无声息，如同猫一般轻盈。</p><p>工厂的铁门被缓缓推开，一股腐朽的气息扑面而来。暗影兽感受到了猎手的气息，发出了低沉的嘶吼。</p><p>"猎手……你终于来了。"</p><p>俊浩微微一笑，右手凝聚出一把光刃："让你久等了。"</p><p>战斗在一瞬间爆发。</p>',
  },
  {
    id: 'manga-003',
    title: '异世界魔法学院',
    slug: 'isekai-magic-academy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20cover%20art%2C%20magical%20academy%20setting%20with%20floating%20castles%2C%20students%20in%20elegant%20robes%2C%20sparkling%20magic%20effects%2C%20warm%20golden%20lighting%2C%20dreamy%20atmosphere%2C%20detailed%20fantasy%20illustration%2C%20beautiful%20composition&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    author: '崔恩熙',
    status: '连载中',
    description: '普通高中生朴真宇在一次意外中穿越到了魔法世界，成为皇家魔法学院最不受欢迎的学生。但他体内的魔力远超所有人想象，一段传奇就此开始。',
    rating: 9.3,
    views: 1890000,
    chapters: 98,
    updatedAt: '2026-08-04',
    tags: ['穿越', '魔法', '学院', '冒险'],
    content: '<h2>第一章：意外穿越</h2><p>朴真宇觉得今天是他人生中最糟糕的一天。月考数学只考了38分，被班主任叫了家长，回家的路上还下起了大雨。</p><p>"为什么我这么倒霉啊——"他仰天长叹。</p><p>就在这时，一道闪电劈中了他身旁的路灯。强光过后，真宇发现自己站在一片陌生的森林里。</p><p>空气中弥漫着淡淡的光芒，远处的天空中有巨大的生物在飞翔。地面上的花草散发着微弱的荧光，美得不真实。</p><p>"这……这是哪里？"</p><p>"你是新来的转学生吧？"一个悦耳的声音从背后响起。</p><p>真宇转过身，看到了一个穿着华丽长袍的银发少女，她正用一双紫色的眼睛好奇地打量着他。</p><p>"我是艾琳·菲尔斯，皇家魔法学院的学生会长。欢迎来到艾泽拉斯魔法学院。"</p>',
  },
  {
    id: 'manga-004',
    title: '第七个目击者',
    slug: 'seventh-witness',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20thriller%20cover%20art%2C%20a%20detective%20character%20in%20rainy%20night%20alley%2C%20dramatic%20shadows%2C%20noir%20atmosphere%2C%20muted%20dark%20tones%20with%20subtle%20warm%20highlights%2C%20suspenseful%20mood%2C%20clean%20illustration%20style&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    author: '郑在民',
    status: '已完结',
    description: '一桩看似简单的失踪案，却牵扯出七年前的连环杀人事件。刑警韩智勋在调查过程中，发现每一个线索都指向一个令人不安的真相。',
    rating: 9.6,
    views: 3120000,
    chapters: 72,
    updatedAt: '2026-07-20',
    tags: ['推理', '犯罪', '悬疑', '反转'],
    content: '<h2>第一章：失踪的女人</h2><p>雨已经下了整整三天。</p><p>刑警韩智勋站在江南区一栋高级公寓的门口，雨水顺着他的雨衣滴落。他的搭档金美英正在向公寓管理员询问情况。</p><p>"失踪者叫沈秀妍，32岁，在附近的设计公司工作。三天前的晚上离开公司后就没有回家。"金美英翻着笔记本说。</p><p>韩智勋走进公寓，房间整洁得有些过分。衣柜里的衣服按颜色排列，厨房的碗碟一尘不染，连垃圾桶都是空的。</p><p>"这个人有强迫症。"他自言自语。</p><p>书桌上放着一本日记，翻开到最后一页。上面只写了一行字：第七个目击者知道真相。</p>',
  },
  {
    id: 'manga-005',
    title: '邻居家的猫',
    slug: 'neighbors-cat',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20comedy%20slice%20of%20life%20cover%20art%2C%20cute%20cat%20and%20young%20woman%20in%20cozy%20apartment%2C%20warm%20sunlight%20through%20window%2C%20pastel%20colors%2C%20heartwarming%20vibe%2C%20clean%20manga%20illustration%2C%20relaxed%20composition&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    category: '搞笑',
    categorySlug: 'comedy',
    author: '尹素拉',
    status: '连载中',
    description: '独居的上班族李秀雅有一天发现邻居的猫总是跑到她的阳台上。更奇怪的是，这只猫似乎能听懂人话？一段温暖有趣的日常故事就此展开。',
    rating: 8.9,
    views: 756000,
    chapters: 45,
    updatedAt: '2026-08-02',
    tags: ['日常', '治愈', '萌宠', '轻松'],
    content: '<h2>第一章：不速之客</h2><p>周六早上七点，李秀雅被一阵奇怪的声音吵醒了。</p><p>她揉着眼睛走到阳台，发现一只橘色的猫正端坐在她的阳台栏杆上，淡定地舔着爪子。</p><p>"你是从哪里来的？"秀雅打开阳台门。</p><p>橘猫抬起头，用一双碧绿色的眼睛看着她，然后优雅地走进客厅，跳上沙发，蜷缩成一团。</p><p>"喂！这是我家！"</p><p>橘猫打了个哈欠，完全不理会她的抗议。</p><p>从那天起，橘猫每天都会来。秀雅渐渐习惯了它的存在，甚至开始给它准备猫粮。她给它取名叫"橘橘"。</p><p>直到有一天，她发现橘橘竟然用爪子在纸上划出了字——虽然歪歪扭扭，但能看出是"饿"字。</p>',
  },
  {
    id: 'manga-006',
    title: '深渊的低语',
    slug: 'whispers-of-abyss',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20horror%20cover%20art%2C%20dark%20shadowy%20figure%20emerging%20from%20abyss%2C%20eerie%20atmosphere%20with%20dim%20red%20lighting%2C%20distorted%20reflections%2C%20psychological%20horror%20vibe%2C%20minimal%20but%20unsettling%20illustration%2C%20dark%20color%20palette&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    category: '恐怖',
    categorySlug: 'horror',
    author: '闵承宇',
    status: '已完结',
    description: '在一座被遗弃的精神病院地下，隐藏着一个古老的秘密。五个年轻人为了拍摄纪录片来到这里，却再也没能全部离开。深渊在呼唤，你听到了吗？',
    rating: 9.1,
    views: 1450000,
    chapters: 38,
    updatedAt: '2026-06-15',
    tags: ['心理恐怖', '悬疑', '惊悚', '灵异'],
    content: '<h2>第一章：废弃医院</h2><p>"这里是兴仁精神病院，建于1968年，于1998年关闭。传说在关闭前的最后一个月，所有的病人都消失不见了。"</p><p>金道勋对着摄像机解说着，他的四名队友正在身后架设设备。他们是YouTube上一个专门探索废弃建筑的频道团队。</p><p>"道勋哥，这里真的很阴森。"摄像师崔雪莉打了个寒颤。</p><p>医院的大厅里弥漫着霉味，墙壁上的油漆大片剥落，露出下面发黑的混凝土。地上的瓷砖有些已经碎裂，踩上去发出咯吱咯吱的声音。</p><p>"大家注意安全，不要走散。"队长朴志浩提醒道。</p><p>他们没有注意到，在二楼的走廊尽头，一个模糊的影子正静静地看着他们。</p>',
  },
  {
    id: 'manga-007',
    title: '王位继承者',
    slug: 'heir-to-throne',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20historical%20drama%20cover%20art%2C%20royal%20prince%20character%20in%20traditional%20Korean%20hanbok%2C%20palace%20background%2C%20epic%20cinematic%20lighting%2C%20rich%20warm%20colors%2C%20dramatic%20composition%2C%20detailed%20historical%20illustration&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    category: '剧情',
    categorySlug: 'drama',
    author: '张慧珍',
    status: '连载中',
    description: '朝鲜王朝末期，最小的王子李宪意外卷入王位争夺战。在血雨腥风的宫廷斗争中，他必须做出抉择——是守护王权，还是追求自由。',
    rating: 9.4,
    views: 1670000,
    chapters: 110,
    updatedAt: '2026-08-01',
    tags: ['历史', '宫廷', '权谋', '古风'],
    content: '<h2>第一章：最小的王子</h2><p>景福宫的深秋，落叶铺满了庭院。</p><p>十四岁的李宪蹲在角落里，正用树枝在地上画画。他是先王最小的儿子——一个几乎被所有人遗忘的王子。</p><p>"殿下，您在做什么？"宫女贞儿端着一盘点心走过来。</p><p>"我在画一只鸟。"李宪抬起头，露出天真的笑容，"你看，它飞得多高啊。"</p><p>贞儿看了看地上的画，心中涌起一阵酸楚。这位小王子画的那只鸟，翅膀被锁链缠住了。</p><p>就在这时，远处传来急促的脚步声。一名侍卫连滚带爬地冲过来："殿下！大殿下的军队已经包围了王宫！请您立即随我离开！"</p><p>李宪手中的树枝掉在地上。他第一次意识到，自己这个"被遗忘的王子"，也逃不过宫廷斗争的漩涡。</p>',
  },
  {
    id: 'manga-008',
    title: '咖啡店的午后',
    slug: 'afternoon-at-cafe',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20slice%20of%20life%20cover%20art%2C%20cozy%20coffee%20shop%20interior%20with%20barista%2C%20warm%20afternoon%20sunlight%2C%20steaming%20coffee%20cup%2C%20relaxed%20atmosphere%2C%20soft%20beige%20and%20brown%20tones%2C%20clean%20illustration%20style%2C%20comfortable%20vibe&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    category: '日常',
    categorySlug: 'slice-of-life',
    author: '宋智敏',
    status: '连载中',
    description: '辞去大公司工作的姜智恩在巷子里开了一家小小的咖啡店。在这里，她遇见了形形色色的人，听他们的故事，也在不知不觉中治愈了自己。',
    rating: 8.7,
    views: 623000,
    chapters: 52,
    updatedAt: '2026-08-03',
    tags: ['治愈', '咖啡', '日常', '温暖'],
    content: '<h2>第一章：辞职</h2><p>"姜智恩小姐，你确定要辞职吗？"</p><p>"是的，部长。非常确定。"</p><p>智恩拿着辞职信的手微微颤抖，但她的语气很坚定。在首尔最大的广告公司工作了五年之后，她终于决定离开。</p><p>走出公司大楼的那一刻，她感到前所未有的轻松。天空似乎比平时更蓝，空气也更新鲜。</p><p>三个月后，在梨泰院一条安静的小巷里，"午后咖啡"开业了。</p><p>店面不大，只有六张桌子。但每一张都是智恩亲自挑选的，墙上挂着她旅行时拍的照片，角落里摆着她从旧书店淘来的书。</p><p>第一位客人是一位头发花白的老爷爷。他点了美式咖啡，坐在窗边看了整个下午的书。</p><p>"好喝。"临走时他说。就这两个字，让智恩开心了一整天。</p>',
  },
  {
    id: 'manga-009',
    title: '星之契约者',
    slug: 'star-contractor',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fantasy%20adventure%20cover%20art%2C%20warrior%20with%20celestial%20powers%20under%20starry%20night%20sky%2C%20glowing%20constellation%20patterns%2C%20epic%20scale%2C%20mystical%20atmosphere%2C%20rich%20cosmic%20colors%2C%20clean%20illustration%20style%2C%20dramatic%20composition&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    category: '奇幻',
    categorySlug: 'fantasy',
    author: '柳志勋',
    status: '连载中',
    description: '十二星座各自选择了契约者，赋予他们超凡的力量。当天秤座的少年觉醒时，一场跨越星界的史诗冒险拉开了序幕。',
    rating: 9.0,
    views: 980000,
    chapters: 66,
    updatedAt: '2026-07-30',
    tags: ['星座', '超能力', '冒险', '战斗'],
    content: '<h2>第一章：星光坠落之夜</h2><p>那是一个普通的周二夜晚，如果天上没有掉下一颗星星的话。</p><p>尹星辰正在屋顶天台复习功课，突然一道银白色的光柱从天而降，将他整个人笼罩其中。光芒散去后，他的右手手背上多了一个天秤座的印记。</p><p>"契约成立。"一个空灵的声音在他脑海中响起。</p><p>"什么契约？"星辰茫然地看着手背。</p><p>"天秤座之星选择了你作为契约者。从现在起，你拥有平衡之力。"</p><p>星辰还没来得及消化这个消息，一道黑影从天边疾驰而来。一个身穿黑色斗篷的人悬浮在半空中，同样有着星座印记——那是天蝎座。</p><p>"又一个觉醒者。"黑影发出低沉的笑声，"可惜，你觉醒得太晚了。"</p>',
  },
  {
    id: 'manga-010',
    title: '恋爱方程式',
    slug: 'love-equation',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20comedy%20cover%20art%2C%20two%20high%20school%20students%20in%20classroom%2C%20one%20is%20math%20genius%20and%20the%20other%20is%20art%20student%2C%20chalkboard%20with%20equations%20in%20background%2C%20bright%20warm%20lighting%2C%20youthful%20atmosphere%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    category: '恋爱',
    categorySlug: 'romance',
    author: '韩艺琳',
    status: '连载中',
    description: '数学天才安宥真和艺术生徐道允，一个是理性至上的学霸，一个是感性浪漫的画家。两个完全不同的人，却因为一次意外的同桌安排，开启了属于他们的恋爱方程式。',
    rating: 9.1,
    views: 1100000,
    chapters: 58,
    updatedAt: '2026-08-04',
    tags: ['校园', '青春', '甜宠', '理科恋爱'],
    content: '<h2>第一章：新同桌</h2><p>"安宥真，从今天起你坐在徐道允旁边。"</p><p>班主任的这句话，在宥真看来就是一场灾难。她看向教室最后一排靠窗的位置——那里坐着全校最"不务正业"的学生，整天只知道画画的美术特长生徐道允。</p><p>宥真抱着书本走过去，面无表情地坐下。</p><p>"哟，年级第一来啦。"道允歪着头看她，嘴角挂着一抹玩味的笑。</p><p>宥真没有理他，拿出数学竞赛练习题开始做。对她来说，三角函数比任何对话都有意义。</p><p>但道允似乎并不打算放过她。他凑过来看了一眼她的习题本："第三题的辅助线画错了。"</p><p>宥真的笔停住了。她仔细看了看，确实错了。</p><p>"你怎么看出来的？"她忍不住问。</p><p>道允耸耸肩："构图感。画画的直觉。"</p><p>那是宥真第一次正眼看向道允。他的眼睛很亮，像盛满了星光。</p>',
  },
  {
    id: 'manga-011',
    title: '地下拳王',
    slug: 'underground-fighter',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20fighting%20action%20cover%20art%2C%20muscular%20fighter%20in%20underground%20arena%2C%20dramatic%20spotlight%2C%20intense%20expression%2C%20sweat%20and%20motion%2C%20dark%20background%20with%20crowd%20silhouettes%2C%20powerful%20composition%2C%20clean%20illustration&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    category: '动作',
    categorySlug: 'action',
    author: '权相佑',
    status: '连载中',
    description: '前国家拳击队选手崔泰浩因伤退役后，为了给妹妹筹集手术费，不得不踏入地下拳场。在这里，他遇见了此生最强的对手——也遇见了重生的自己。',
    rating: 9.3,
    views: 1750000,
    chapters: 82,
    updatedAt: '2026-08-02',
    tags: ['格斗', '热血', '兄弟情', '励志'],
    content: '<h2>第一章：最后一搏</h2><p>医院的消毒水味道总是让崔泰浩感到窒息。</p><p>"手术费还差三千万韩元。"医生翻着病历本，语气平淡，好像三千万只是一个数字。</p><p>但对泰浩来说，这是天文数字。他在建筑工地搬砖，一个月只能挣两百多万。妹妹的肾病需要尽快手术，时间不等人。</p><p>那天晚上，他的好友金哲民带他去了一个地方——江南区地下三层的一个秘密场所。</p><p>震耳欲聋的呐喊声，空气中弥漫着汗水和血的味道。中央的铁笼里，两个人正在搏斗，没有规则，没有保护，直到一方倒下。</p><p>"赢一场，两千万。"哲民说。</p><p>泰浩看着铁笼，握紧了拳头。</p>',
  },
  {
    id: 'manga-012',
    title: '灵媒师的预言',
    slug: 'mediums-prophecy',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20supernatural%20mystery%20cover%20art%2C%20female%20medium%20with%20tarot%20cards%20in%20dim%20candlelit%20room%2C%20mysterious%20smoke%20and%20sparkles%2C%20purple%20and%20gold%20color%20accents%2C%20ethereal%20atmosphere%2C%20detailed%20illustration%2C%20spiritual%20vibe&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    category: '悬疑',
    categorySlug: 'mystery',
    author: '郑在民',
    status: '已完结',
    description: '拥有预言能力的灵媒师崔允儿，每次占卜都以生命为代价。当她预见到自己将在三十天内死去时，一场与时间赛跑的谜题开始了。',
    rating: 9.2,
    views: 1320000,
    chapters: 48,
    updatedAt: '2026-05-10',
    tags: ['超自然', '预言', '灵异', '推理'],
    content: '<h2>第一章：最后的预言</h2><p>崔允儿点燃了第七根蜡烛。</p><p>狭小的占卜室内，烛光摇曳。坐在她对面的是一位四十多岁的女人，满脸焦虑。</p><p>"我丈夫……他是不是出轨了？"女人小声问。</p><p>允儿闭上眼睛，双手轻轻放在水晶球上。三秒后，她睁开眼："他没有出轨。他在加班，为了给你们买新房。"</p><p>女人松了一口气，付了钱离开。</p><p>这种小占卜对允儿来说轻而易举。但今天，她感觉有些不对劲。从早上起床开始，太阳穴就一直跳痛——这是预言的征兆，而且是大预言。</p><p>她拿出一面古铜镜，念动咒语。镜面上渐渐浮现出画面——一个人影倒在一滩血泊中。那个人影越来越清晰，最后，允儿看到了自己的脸。</p><p>三十天后，她将死去。</p>',
  },
];

export const sortedMangaByUpdate = [...mangaList].sort((a, b) => {
  return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
});

export const sortedMangaByPopular = [...mangaList].sort((a, b) => b.views - a.views);

export const getMangaByCategory = (categorySlug: string) => {
  return mangaList.filter((m) => m.categorySlug === categorySlug);
};

export const getMangaById = (id: string) => {
  return mangaList.find((m) => m.id === id) || null;
};

export const getMangaBySlug = (slug: string) => {
  return mangaList.find((m) => m.slug === slug) || null;
};

export const featuredManga = mangaList.filter((m) => m.rating >= 9.3);